// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueMeta from 'vue-meta'
import Toasted from 'vue-toasted'

import { library } from "@fortawesome/fontawesome-svg-core"; 
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"; 

import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from "@fortawesome/free-regular-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";

import './assets/css/bootstrap.min.css'
import './assets/css/bootstrap.css'
import './assets/css/slick-theme.css'
import './assets/css/slick.css'
import './assets/css/custom.css'


Vue.use(Toasted)

let options = {
  containerClass: 'opsnow-toasted-container',
  position: 'top-center',
  mode: 'override',
  duration: 3000
}

Vue.toasted.register('showMessage',
  (payload) => {
    if (!payload.message) {
      return 'Oops.. Something Went Wrong..'
    }
    if(payload.type){
      options.type = payload.type
    }
    return payload.message
  },
  options
)

library.add(fas, far, fab); 
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

// VueMeta
// Vue.use(VueMeta, {
//   // optional pluginOptions
//   refreshOnceOnNavigation: true,
//   // vmid를 사용하기 위한 옵션
//   attribute: 'data-vue-meta'
// });



// WEBPACK FOOTER //
// ./src/main.js